import { render, staticRenderFns } from "./WorkspaceInvite.vue?vue&type=template&id=4cbbf8a6&scoped=true&"
import script from "./WorkspaceInvite.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceInvite.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceInvite.vue?vue&type=style&index=0&id=4cbbf8a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbbf8a6",
  null
  
)

export default component.exports